export const MARGIN_VIEW_STANDARD = "standard";
export const MARGIN_VIEW_NON_EXCLUDED = "non_excluded";

/** Cookie scopes — one per quote header panel that supports margin view toggle. */
export const MARGIN_VIEW_SCOPE_ONE_TIME = "gross_profit";
export const MARGIN_VIEW_SCOPE_RECURRING = "recurring_profit";

const MARGIN_VIEW_COOKIE_PREFIX = "quote_header_margin_view_";
const MARGIN_VIEW_COOKIE_EXPIRES_DAYS = 365;

const isValidMarginView = (value) =>
	value === MARGIN_VIEW_STANDARD || value === MARGIN_VIEW_NON_EXCLUDED;

export const readStoredMarginView = (scope) => {
	if (!scope) {
		return MARGIN_VIEW_STANDARD;
	}
	const stored = quosal.util.cookie(`${MARGIN_VIEW_COOKIE_PREFIX}${scope}`);
	return isValidMarginView(stored) ? stored : MARGIN_VIEW_STANDARD;
};

export const writeStoredMarginView = (scope, view) => {
	if (!scope || !isValidMarginView(view)) {
		return;
	}
	quosal.util.cookie(`${MARGIN_VIEW_COOKIE_PREFIX}${scope}`, view, {
		expires: MARGIN_VIEW_COOKIE_EXPIRES_DAYS,
		path: "/"
	});
};

export const marginViewScopeForPanelKey = (panelKey) => {
	if (panelKey === MARGIN_VIEW_SCOPE_ONE_TIME || panelKey === MARGIN_VIEW_SCOPE_RECURRING) {
		return panelKey;
	}
	return null;
};
